import { isValidPhoneNumber } from 'libphonenumber-js'
import * as v from 'valibot'
import { COUNTRIES, countryCodeFromName, DEFAULT_COUNTRY } from '#shared/utils/countries'
import { DateOfBirthSchema } from '#shared/utils/dateOfBirth'

const REQUIRED = 'This field is required'

function requiredString(max: number) {
  return v.pipe(v.string(REQUIRED), v.trim(), v.nonEmpty(REQUIRED), v.maxLength(max))
}

export const PrescriptionSchema = v.pipe(
  v.object({
    firstName: requiredString(255),
    lastName: requiredString(255),
    dateOfBirth: DateOfBirthSchema,
    street: requiredString(255),
    city: requiredString(255),
    county: requiredString(255),
    country: v.pipe(
      requiredString(255),
      v.picklist(COUNTRIES.map(c => c.name), 'Please select a country from the list'),
    ),
    postCode: requiredString(32),
    email: v.pipe(requiredString(255), v.email('Please enter a valid email address')),
    mobile: requiredString(32),
    message: requiredString(5000),
    pharmacyInformation: requiredString(5000),
    // Opting out is the default: marketing needs explicit consent.
    marketingConsent: v.optional(v.boolean(), false),
    // Honeypot: real users never see this field, bots tend to fill it in.
    company: v.optional(v.string(), ''),
  }),
  // Numbers typed without an international prefix are read as local to the selected country.
  // partialCheck runs as soon as these two fields are valid, even if others still aren't.
  v.forward(
    v.partialCheck(
      [['mobile'], ['country']],
      ({ mobile, country }) => isValidPhoneNumber(mobile, countryCodeFromName(country) ?? DEFAULT_COUNTRY),
      'Please enter a valid mobile number',
    ),
    ['mobile'],
  ),
)

export type Prescription = v.InferOutput<typeof PrescriptionSchema>
